/** See `src/i18n/locales/en/subscription.ts` for context on the `// legal` keys. */
export const subscription = {
  title: 'Abonnement',
  lead: 'Beheer je eigen abonnement — plan, betaling en opzegging.',
  dialogCancel: 'Annuleren',
  status: {
    title: 'Status',
    active: 'Actief',
    inactive: 'Inactief',
    tier: 'Plan',
    expires: 'Verloopt op',
    autoRenews: 'Wordt automatisch verlengd',
    doesNotRenew: 'Wordt niet verlengd',
    nextCharge: 'Volgende afschrijving',
    blocked: 'Je kunt op dit moment geen webabonnement starten.',
  },
  plans: {
    title: 'Plannen',
    monthly: 'Maandelijks',
    yearly: 'Jaarlijks',
    perMonth: '{{price}} / maand',
    perYear: '{{price}} / jaar',
    subscribe: 'Abonneren',
    current: 'Huidig plan',
    switchToYearly: 'Overstappen naar jaarlijks',
    switchToMonthly: 'Overstappen naar maandelijks',
    // legal
    switchWarning:
      'Overstappen zegt je huidige abonnement op en start het nieuwe direct op hetzelfde machtigingsmandaat. De overlap tussen de twee periodes wordt niet gecrediteerd — je kunt daarvoor dubbel worden belast.',
    switchConfirm: 'Ja, plan wijzigen',
    blocked: 'Je hebt al een actief abonnement, dus kan nu geen ander plan worden gestart.',
  },
  manage: {
    title: 'Beheren',
    cancel: 'Abonnement opzeggen',
    cancelConfirm: 'Ja, opzeggen',
    cancelled: 'Opgezegd — toegang blijft tot {{date}}.',
    // legal
    proRataNote:
      'Bij het jaarplan wordt bij opzegging na de eerste betaaltermijn de ongebruikte volledige maanden terugbetaald en eindigt de toegang direct, in plaats van aan het einde van de periode.',
    withdraw: 'Herroepen (binnen 14 dagen)',
    withdrawHint: 'Beschikbaar tot 14 dagen na je eerste betaling, eenmalig, per abonnement.',
  },
  history: {
    title: 'Historie',
    empty: 'Nog geen aankopen.',
    date: 'Datum',
    period: 'Periode',
    channel: 'Kanaal',
    state: 'Status',
    state_granted: 'Toegekend',
    state_refunded: 'Terugbetaald',
    state_revoked: 'Ingetrokken',
    state_charged_back: 'Chargeback',
    state_rejected: 'Geweigerd',
    invoice: 'Factuur',
    withdrawLink: 'Herroepen',
    manageLink: 'Beheren in de winkel',
  },
  checkout: {
    title: 'Afrekenen',
    lead: 'Controleer je plan voordat je doorgaat naar Mollie.',
    plan: 'Plan',
    price: 'Prijs',
    // legal — §7.5 toestemming onmiddellijke uitvoering, letterlijk uit
    // PLAN-FASE1.md overgenomen.
    consentLabel:
      'Ik wil dat de dienst direct start en weet dat ik daarmee bij herroeping naar rato betaal',
    start: 'Doorgaan naar Mollie',
    errorAlreadySubscribed: 'Je hebt al een actief abonnement.',
    errorProductUnavailable: 'Dit plan is op dit moment niet beschikbaar.',
  },
  return: {
    title: 'Betaalstatus',
    waiting: 'We wachten nog op de bevestiging van je betaling.',
    success: 'Betaling ontvangen — je abonnement is actief.',
    backToSubscription: 'Terug naar je abonnement',
  },
  withdraw: {
    title: 'Abonnement herroepen',
    // legal — art. 6:230oa BW herroepingsrecht.
    lead: 'Herroepen binnen je herroepingstermijn van 14 dagen beëindigt je toegang direct — anders dan opzeggen, wat doorloopt tot het einde van de reeds betaalde periode.',
    refundTypeFull: 'Je ontvangt een volledige terugbetaling.',
    refundTypeProRata: 'Je ontvangt een naar rato terugbetaling voor het nog niet gebruikte deel.',
    refundAmount: 'Terug te betalen bedrag',
    deadline: 'Uiterste datum',
    confirm: 'Herroepen en toegang nu beëindigen',
    confirmed: 'Herroepen — {{amount}} wordt terugbetaald.',
    errorWindowExpired: 'De herroepingstermijn van 14 dagen is verstreken.',
    errorAlreadyWithdrawn: 'Je hebt dit abonnement al herroepen.',
  },
} as const;
